import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultipleNeutral2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "multiple-neutral-2" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 7.5,
			cy: 7.875,
			r: 4.125
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M.75,20.25a6.75,6.75,0,0,1,13.5,0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 17.727,
			cy: 10.125,
			r: 3.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.813,15.068A5.526,5.526,0,0,1,23.25,20.25"
		})
	]
});
export default SvgMultipleNeutral2;
